import React from "react";
import { Link } from "react-router-dom";

const DiscountOne = () => {
  return (
    <section className="discount py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {/* Left Side */}
          <div className="col-xl-6">
            <div
              className="discount-item rounded-16 position-relative overflow-hidden h-100 d-flex flex-column justify-content-center p-20"
              style={{
                border: "2px solid #3243b4",
                backgroundColor: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
            >
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div style={{ flex: 1 }}>
                  <h5
                    className="fw-bold mb-3"
                    style={{ color: "#3243b4", fontSize: "25px" }}
                  >
                    Best Laser Printers for Home & Office
                  </h5>
                  <p
                    className="mb-4 text-secondary"
                    style={{ fontSize: "15px", lineHeight: "1.6" }}
                  >
                    Discover high-performance laser printers built for speed,
                    precision, and efficiency. At Printing Dealz, we offer
                    top-rated models perfect for home offices and businesses,
                    delivering crisp prints and cost-effective results.
                  </p>
                  <Link
                    to="/laser-printers"
                    className="btn btn-outline-danger rounded-pill px-4 py-2 fw-semibold"
                    style={{
                      borderWidth: "2px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Shop Now{" "}
                    <i
                      className="ph ph-shopping-cart-simple ms-2"
                      style={{ fontSize: "18px" }}
                    ></i>
                  </Link>
                </div>

                <img
                  src="assets/images/thumbs/discount-img1.png"
                  alt=""
                  className="d-sm-block d-none"
                  style={{
                    maxHeight: "180px",
                    borderRadius: "12px",
                    border: "1px solid #eee",
                    background: "#fafafa",
                    padding: "8px",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="col-xl-6">
            <div
              className="discount-item rounded-16 position-relative overflow-hidden h-100 d-flex flex-column justify-content-center p-20"
              style={{
                border: "2px solid #3243b4",
                backgroundColor: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
            >
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div style={{ flex: 1 }}>
                  <h5
                    className="fw-bold mb-3"
                    style={{ color: "#3243b4", fontSize: "25px" }}
                  >
                    Premium Ink, Toner & Paper Supplies
                  </h5>
                  <p
                    className="mb-4 text-secondary"
                    style={{ fontSize: "15px", lineHeight: "1.6" }}
                  >
                    Keep your printer running flawlessly with genuine ink,
                    toner, and paper from Printing Dealz. Designed for
                    consistent quality and smooth performance, our supplies
                    ensure professional results every time.
                  </p>
                  <Link
                    to="/toner-papers"
                    className="btn btn-outline-danger rounded-pill px-4 py-2 fw-semibold"
                    style={{
                      borderWidth: "2px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    Shop Now{" "}
                    <i
                      className="ph ph-shopping-cart-simple ms-2"
                      style={{ fontSize: "18px" }}
                    ></i>
                  </Link>
                </div>

                <img
                  src="assets/images/thumbs/discount-img2.png"
                  alt=""
                  className="d-sm-block d-none"
                  style={{
                    maxHeight: "180px",
                    borderRadius: "12px",
                    border: "1px solid #eee",
                    background: "#fafafa",
                    padding: "8px",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .discount-item:hover {
            transform: translateY(-6px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.12);
          }
          .btn-outline-danger:hover {
            background-color: #e63946;
            color: #fff !important;
          }
        `}
      </style>
    </section>
  );
};

export default DiscountOne;
